import createIcon from '../../createIcon';

/**
 * @component @name Hail
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNSA2QzExLjQgNiAxMC41IDUuMSAxMC41IDRDMTAuNSAyLjkgMTEuNCAyIDEyLjUgMkMxMy42IDIgMTQuNSAyLjkgMTQuNSA0QzE0LjUgNS4xIDEzLjYgNiAxMi41IDZaTTE3LjUgMkgxOS41VjIuNEMxOS40IDQuNiAxOC43IDYuMyAxNy4yIDcuNUMxNi43IDcuOSAxNi4xIDguMiAxNS41IDguNFYyMkgxMy41VjE2SDExLjVWMjJIOS41VjEwLjFDOS4yIDEwLjIgOSAxMC4zIDguOSAxMC40QzggMTEuMSA3LjUxIDEyIDcuNSAxMy41VjE0SDUuNVYxMy41QzUuNSAxMS41IDYuMjEgOS45MSA3LjYxIDguNzFDOC43MSA3LjgxIDEwLjUgNyAxMi41IDdDMTQuNSA3IDE1LjE4IDYuNTQgMTUuOTggNS45NEMxNi45OCA1LjE0IDE3LjUgNCAxNy41IDIuNVYyWk00LjUgMTZINy41VjIySDQuNVYxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Hail = createIcon('Hail', [
  [
    'path',
    {
      d: 'M12.5 6C11.4 6 10.5 5.1 10.5 4C10.5 2.9 11.4 2 12.5 2C13.6 2 14.5 2.9 14.5 4C14.5 5.1 13.6 6 12.5 6ZM17.5 2H19.5V2.4C19.4 4.6 18.7 6.3 17.2 7.5C16.7 7.9 16.1 8.2 15.5 8.4V22H13.5V16H11.5V22H9.5V10.1C9.2 10.2 9 10.3 8.9 10.4C8 11.1 7.51 12 7.5 13.5V14H5.5V13.5C5.5 11.5 6.21 9.91 7.61 8.71C8.71 7.81 10.5 7 12.5 7C14.5 7 15.18 6.54 15.98 5.94C16.98 5.14 17.5 4 17.5 2.5V2ZM4.5 16H7.5V22H4.5V16Z',
      key: '1ok4e1',
    },
  ],
]);

export default Hail;
